export type ActionType =
  | 'SET_CONTACT_DATA'
  | 'REQUEST_CONTACT_DATA'
  | 'RECEIVED_CONTACT_DATA'
  | 'ERROR_CONTACT_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialState = {
  isFetching: true,
  data: {},
  error: {},
};

const Contact = (state = initialState, action: Partial<ActionProps>) => {
  switch (action.type) {
    case 'REQUEST_CONTACT_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_CONTACT_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_CONTACT_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default Contact;
